import { Duration } from "@tento-chrono";

export type PomodoroTemplate = {
  duration: Duration.Time;
  color: string;
  label: string;
  identifier: string;
};

export namespace PomodoroTemplate {
  export const ALL: PomodoroTemplate[] = [
    {
      duration: Duration.Time.mins(25),
      color: "var(--red)",
      label: "Pomodoro",
      identifier: "pomodoro",
    },
    {
      duration: Duration.Time.mins(5),
      color: "var(--green)",
      label: "Short Break",
      identifier: "shortBreak",
    },
    {
      duration: Duration.Time.mins(15),
      color: "var(--blue)",
      label: "Long Break",
      identifier: "longBreak",
    },
  ];

  export const DEBUG: PomodoroTemplate = {
    duration: Duration.Time.secs(5),
    color: "var(--orange)",
    label: "Debug",
    identifier: "dbgu",
  };
}
